import type { Nullish } from "@/types";
import { typedObjectEntries } from "@/utils/types.ts";

export const replaceStringVars = (text: string, vars: Record<string, Nullish<string | number>>) => {
    return typedObjectEntries(vars).reduce<string>((acc, [key, value]) => {
        if (typeof value === "undefined" || value === null) return acc;

        return acc.replaceAll(`{${key}}`, `${value}`);
    }, text);
};

export class StringView {
    #text: string;

    constructor(inputText: string) {
        this.#text = inputText;
    }

    destructiveSlice(length: number) {
        const slice = this.#text.slice(0, length);
        this.#text = this.#text.slice(slice.length);

        return slice;
    }
}
